import type { BadgeVariations } from '@synqo/frontend-component-library';
import { EnumCommandOutcome } from './Generated';

export const getEnumCommandOutcomeLabel = (outcome: EnumCommandOutcome): string => {
    switch (outcome) {
        case EnumCommandOutcome.Succeeded:
            return 'Erfolgreich';
        case EnumCommandOutcome.Rejected:
            return 'Abgelehnt';
        case EnumCommandOutcome.Failed:
            return 'Fehlgeschlagen';
        case EnumCommandOutcome.Forbidden:
            return 'Nicht berechtigt';
        default:
            return 'Unbekannt';
    }
};

export const getBadgeVariantByCommandOutcome = (outcome: EnumCommandOutcome): BadgeVariations => {
    switch (outcome) {
        case EnumCommandOutcome.Succeeded:
            return 'success';
        case EnumCommandOutcome.Rejected:
            return 'warning';
        case EnumCommandOutcome.Failed:
            return 'danger';
        case EnumCommandOutcome.Forbidden:
            return 'danger';
        default:
            return 'default';
    }
};
